import { SlideComponentAudioRecord } from '@/types/slide';
import { SlideComponentCreator } from './factory';

export class SlideComponentAudioRecordCreator extends SlideComponentCreator {
    public create(id: string): SlideComponentAudioRecord {
        return {
            id: id,
            type: 'audioRecord',
            pos: {
                x: 0,
                y: 0,
            },
            size: { width: 214, height: 168 },
            content: {},
        };
    }
}
